export default "__VITE_ASSET__Cn9WIzJH__"